import { render, staticRenderFns } from "./FlowList.vue?vue&type=template&id=2deac118&scoped=true&"
import script from "./FlowList.vue?vue&type=script&lang=js&"
export * from "./FlowList.vue?vue&type=script&lang=js&"
import style0 from "./FlowList.vue?vue&type=style&index=0&id=2deac118&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2deac118",
  null
  
)

export default component.exports